import CircleAlert from 'lucide-react/dist/esm/icons/circle-alert.mjs'
import CircleCheck from 'lucide-react/dist/esm/icons/circle-check.mjs'

export function InlineNotice({ kind = 'info', children }: { kind?: 'info' | 'success' | 'warning' | 'error'; children: React.ReactNode }) {
  return (
    <div className={`notice notice-${kind}`} role={kind === 'error' ? 'alert' : 'status'}>
      {kind === 'success' ? <CircleCheck size={18} /> : <CircleAlert size={18} />}
      <span>{children}</span>
    </div>
  )
}
